'use strict'
const distinct = (arr, identifier) => {
    return [...new Set(arr.map(a => a[identifier]))].map(value => arr.find(a => a[identifier] === value))
}

const doesEventExist = (eventName, eventBus) => {
    return eventBus._events && eventBus._events[eventName] && eventBus._events[eventName].length > 0;
}

export {
    distinct,
    doesEventExist
}